import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Apartments from './pages/Apartments'
import ApartmentHub from './pages/ApartmentHub'
import { Availabilities } from './pages/Availabilities'
import Bookings from './pages/Bookings'
import Reviews from './pages/Reviews'
import Payments from './pages/Payments'
import Inquiries from './pages/Inquiries'
import DeferredBookingInquiries from './pages/DeferredBookingInquiries'
import Content from './pages/Content'
import Settings from './pages/Settings'
import Login from './pages/Login'
import MyInvitations from './pages/MyInvitations'
import SupportCases from './pages/SupportCases'
import BankTransfers from './pages/BankTransfers'
import InvitationTokenPage from './pages/InvitationTokenPage'
import { useAuthStore } from './store/authStore'

function App() {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Login />
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="apartments" element={<Apartments />} />
          <Route path="apartments/new" element={<ApartmentHub />} />
          <Route path="apartments/:id" element={<ApartmentHub />} />
          <Route path="apartments/:apartmentId/availabilities" element={<Availabilities />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="payments" element={<Payments />} />
          <Route path="inquiries" element={<Inquiries />} />
          <Route path="deferred-bookings" element={<DeferredBookingInquiries />} />
          <Route path="support-cases" element={<SupportCases />} />
          <Route path="bank-transfers" element={<BankTransfers />} />
          <Route path="content" element={<Content />} />
          <Route path="settings" element={<Settings />} />
          <Route path="my-invitations" element={<MyInvitations />} />
          <Route path="invitations/:token" element={<InvitationTokenPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App


